export const privacyPolicy = [
  {
    title: '1. Informações Gerais',
    description:
      'Esta Política de Privacidade se aplica a todos os usuários e visitantes do site https://rifaqui.com.br, e integra os Termos e Condições de Uso da plataforma.\n\nEste documento foi elaborado em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) e o Regulamento da União Europeia n.º 2016/679 (GDPR), podendo ser atualizado conforme mudanças legais. Recomendamos que o usuário consulte periodicamente esta seção.',
  },
  {
    title: '2. Coleta de Dados Pessoais',
    description:
      'A RIFAQUI coleta dados pessoais do usuário nas seguintes situações:\n\n- Cadastro na plataforma: nome, e-mail, telefone (WhatsApp), data de nascimento, e cidade/UF.\n- Compra de títulos: dados transacionais como valor pago, método de pagamento e identificador da transação Pix.\n- Navegação no site: endereço IP, navegador, dispositivo utilizado, localização aproximada, interações com páginas e preferências de navegação.\n- Comunicação com suporte: histórico de conversas e mensagens enviadas pelos canais de atendimento.\n\nA RIFAQUI não coleta dados sensíveis como orientação sexual, convicção religiosa, saúde, genética, entre outros.',
  },
  {
    title: '3. Finalidade do Uso dos Dados',
    description:
      'Os dados pessoais são utilizados para:\n- Processar a participação em rifas e validar pagamentos;\n- Emitir e enviar comprovantes;\n- Notificar ganhadores;\n- Garantir segurança e prevenir fraudes;\n- Melhorar a experiência do usuário;\n- Cumprir exigências legais;\n- Oferecer suporte.',
  },
  {
    title: '4. Armazenamento dos Dados',
    description:
      'Os dados são armazenados pelo tempo necessário para a execução dos serviços contratados, cumprimento de exigências legais e preservação de histórico.\nO usuário pode solicitar a exclusão dos dados, salvo obrigação legal de retenção.',
  },
  {
    title: '5. Segurança dos Dados',
    description:
      'Medidas como criptografia SSL, controle de acesso restrito e servidores protegidos são adotadas.\nA RIFAQUI não se responsabiliza por ataques externos ou descuido do usuário.',
  },
  {
    title: '6. Compartilhamento de Dados',
    description:
      'Dados podem ser compartilhados com provedores de serviços, em cumprimento de ordens judiciais ou com organizadores para entrega de prêmios.',
  },
  {
    title: '7. Transferência Internacional',
    description:
      'Serviços podem estar hospedados fora do Brasil. Ao utilizar a plataforma, o usuário consente com essa transferência.',
  },
  {
    title: '8. Uso de Cookies',
    description:
      'Cookies são usados para melhorar navegação, coletar estatísticas e lembrar preferências.\nÉ possível desativar nas configurações do navegador.',
  },
  {
    title: '9. Consentimento',
    description:
      'Ao usar a plataforma e fornecer dados, o usuário concorda com esta política. É possível revogar o consentimento a qualquer momento.',
  },
  {
    title: '10. Alterações nesta Política',
    description:
      'Alterações podem ocorrer a qualquer momento e entram em vigor após publicação. Mudanças significativas serão comunicadas.',
  },
  {
    title: '11. Foro',
    description:
      'Aplica-se a legislação brasileira, com foro da comarca da sede da empresa.',
  },
]

export const termsOfUse = [
  {
    title: '1. Aceitação dos Termos',
    description:
      'Ao utilizar a plataforma, o usuário aceita integralmente os Termos de Uso e Política de Privacidade.',
  },
  {
    title: '2. Objetivo da Plataforma',
    description:
      'A RIFAQUI conecta organizadores a usuários, atuando como intermediadora de rifas e sorteios automatizados.',
  },
  {
    title: '3. Participação em Rifas',
    description:
      'O usuário participa acessando “Campanhas”, escolhendo uma rifa ativa e adquirindo títulos. A confirmação do pagamento valida a participação.',
  },
  {
    title: '4. Pagamento e Confirmação',
    description:
      'Aceita-se Pix. O pagamento é automático e, após aprovado, o usuário recebe comprovantes e visualiza seus títulos.',
  },
  {
    title: '5. Sorteio e Transparência',
    description:
      'O sorteio é realizado somente após venda total dos números e é totalmente automatizado, com resultado divulgado publicamente.',
  },
  {
    title: '6. Premiação',
    description:
      'O ganhador é notificado via WhatsApp. A entrega é combinada com o organizador. Pode haver custos, se previstos no regulamento.',
  },
  {
    title: '7. Cadastro e Conta',
    description:
      'É necessário fornecer dados reais e manter sigilo das credenciais. A conta não pode ser transferida.',
  },
  {
    title: '8. Segurança e Privacidade',
    description:
      'Os dados são protegidos conforme a LGPD e usados apenas para operações da plataforma, salvo obrigação legal.',
  },
  {
    title: '9. Responsabilidades',
    description:
      'Usuário: uso ético, dados corretos, proteger conta. Plataforma: sorteios seguros, suporte, segurança dos dados.',
  },
  {
    title: '10. Suporte',
    description: 'Dúvidas podem ser encaminhadas via “Fale Conosco”.',
  },
  {
    title: '11. Alterações nos Termos',
    description:
      'A plataforma pode alterar os termos a qualquer momento. O uso contínuo indica concordância.',
  },
  {
    title: '12. Foro',
    description: 'Fica eleito o foro da comarca de Capivari, SP.',
  },
]
